import { FirebaseData } from "../General/FirebaseData";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";
import { SubtaskData } from "./SubtaskData";
import { Timestamp } from "firebase/firestore";
import { CompanyData } from "../Company/CompanyData";
import { CompanyInvoiceReceiverData } from "../Company/CompanyInvoiceReceiverData";

export interface InvoicedToData {
  company: CompanyData;
  invoiceReceiver: CompanyInvoiceReceiverData;
}
export class DeviationCostData extends FirebaseData {
  costType: "timeEntry" | "cost" = "cost";

  unitPrice?: number;
  description: string = "";
  vat: number = 25;
  unitCount?: number;
  task?: SubtaskData;
  startDate?: Date;
  endDate?: Date;
  user?: UserData;
  invoicedTo?: InvoicedToData;

  setup(data: any) {
    // CostType
    if (data.costType === "timeEntry" || data.costType === "cost") {
      this.costType = data.costType;
    }
    this.description = typeof data.description === "string" ? data.description : "";
    this.unitPrice = typeof data.unitPrice === "number" ? data.unitPrice : undefined;
    this.vat = typeof data.vat === "number" ? data.vat : 25;
    this.unitCount = typeof data.unitCount === "number" ? data.unitCount : undefined;
    this.user = typeof data.userID === "string" ? LocalData.users.addData(data.userID) : undefined;

    if (
      typeof data.invoicedTo === "object" &&
      typeof data.invoicedTo.companyID === "string" &&
      typeof data.invoicedTo.invoiceReceiverID === "string"
    ) {
      this.invoicedTo = {
        company: LocalData.companies.addData(data.invoicedTo.companyID),
        invoiceReceiver: LocalData.companies.addData(data.invoicedTo.companyID).invoiceReceivers.addData(data.invoicedTo.invoiceReceiverID),
      };
    }

    // StartDate
    this.startDate = undefined;
    if (data.startDate as Timestamp) {
      this.startDate = (data.startDate as Timestamp).toDate();
    }
    if (this.isValidDate(data.startDate)) {
      this.startDate = data.startDate;
    }
    // EndDate
    this.endDate = undefined;
    if (data.endDate as Timestamp) {
      this.endDate = (data.endDate as Timestamp).toDate();
    }
    if (this.isValidDate(data.endDate)) {
      this.endDate = data.endDate;
    }
  }

  calculateCost(includingVat: boolean): number {
    if (this.costType === "timeEntry") {
      if (!this.startDate || !this.endDate) return 0;
      const hours = (this.endDate.getTime() - this.startDate.getTime()) / (1000 * 60 * 60);
      return includingVat ? hours * (this.unitPrice ?? 0) * (1 + this.vat / 100) : hours * (this.unitPrice ?? 0);
    } else {
      let base = (this.unitPrice ?? 0) * (this.unitCount ?? 0);
      if (includingVat) {
        return base * (1 + this.vat / 100);
      }
      return base;
    }
  }
}
